export default __webpack_public_path__ + "static/media/intermediary.34272d80.svg";